import {useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../../models'
import {getModulesService} from '../../../../../hoteleria/features/modules/services'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {useTypeBuilding} from '../../../../hooks/typeBuilding/useTypeBuilding'

const TableTypeBuilding = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    clearTable,
    updateTable,
    setClearTable,
    setUpdateTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useLimpieza()

  const {searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, companies} = useCompanies()
  const {getClients, clients} = useClients()
  const {getSites, sites} = useSites()
  const {getCampaments, campaments} = useCampaments()
  const {
    getStatusModules,
    getTypeModules,
    getTypeBuildings,
    statusModules,
    typeModules,
    typeBuildings,
  } = useParameters()
  // const { getModules: getModulesService } = useTypeBuilding()

  const getModules = async () => {
    try {
      setLoading(true)
      const {data: response} = await getModulesService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getModules()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    } else {
      getModules()
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getClients({isCombo: true}, 1)
    getSites({isCombo: true}, 1)
    getCampaments({isCombo: true}, 1)
    getTypeModules({pageNumber: 1, size: 200, tableName: 'TipoModulo'})
    getStatusModules({pageNumber: 1, size: 200, tableName: 'EstadoModulo'})
    getTypeBuildings({pageNumber: 1, size: 200, tableName: 'TipoEdificacion'})
    return () => {
      clearSearchValues()
    }
  }, [])

  const handleViewPanel = (data: any) => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: data.Id,
      idToDelete: '',
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-type-of-building',
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={companies}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={clients}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={sites} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={campaments}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Edificación'
            name='TipoEdificacionId'
            selecteable
            data={typeBuildings}
          />
        ),
        accessor: 'TipoEdificacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name={'Codigo'}
            searcheable
          />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Módulo'
            name='TipoModuloId'
            selecteable
            data={typeModules}
          />
        ),
        accessor: 'TipoModulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Módulo'
            name='EstadoModuloId'
            selecteable
            data={statusModules}
          />
        ),
        accessor: 'EstadoModulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Pisos'
            name='NroPisos'
            searcheable
            number
          />
        ),
        accessor: 'NroPisos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleViewPanel(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
    ],
    [companies, clients, sites, campaments, typeModules, typeBuildings, statusModules, selectedOn],
  )

  return (
    <KTCard shadow className='m-5'>
      <KTable data={data} columns={columns} />
      {loading ? <KTableLoading title='Cargando...' /> : null}
    </KTCard>
  )
}

export const TypeOfBuildingTable = () => {
  return (
    <KTableProvider>
      <TableTypeBuilding />
    </KTableProvider>
  )
}
